import React from "react";
import { withTranslation } from "react-i18next";
import Form from "../common/form";
import {
  getFormButtonText,
  getFormTitleText,
  getJoiSchema,
  getStateObject,
} from "../common/formUtils";
import designationJson from "./designation.json"
import designationService from "./designation.service";
import OrgContext from "../app-context";

class DesignationForm extends Form {
  constructor() {
    super();
    this.formJson = designationJson;
    this.state = {
      data: getStateObject(this.formJson.groups),
      errors: {},
      dropDowns: {},
    };
    this.schema = getJoiSchema(this.formJson.groups);
  }

  
  async populateForm() {
    const id = this.props.id?this.props.id:this.props.match.params.id;
    if (id === "new") return;
    try {
      const { data } = await designationService.get(id);
      this.mapToViewModel(data);
    } catch (ex) { }
  }

  async componentDidMount() {
   await this.populateForm();
  }

  doSubmit = async (id) => {
    try {
      if (id === "new") await designationService.create(this.state.data);
      else await designationService.update(this.state.data);
      // this.props.history.goBack();
      this.props.onSave();
    } catch (ex) {
      // logger.log(ex.response.data.message);
    }
  };

  render() {
    const { t } = this.props;
    const { dropDowns } = this.state;
    const id = this.props.id?this.props.id:this.props.match.params.id;

    const buttonText = getFormButtonText(id);

    const titleText = getFormTitleText(id, this.formJson.alias);
    return (
      // <Card>
          // <CardHeader title={t(titleText)} action={<BackButton {...this.props} />} />
        <form onSubmit={(event) => this.handleSubmit(event, id)}>

          {this.renderForm(this.formJson, dropDowns)}

        </form>
      // </Card>
    );
  }
}
DesignationForm.contextType = OrgContext;
export default withTranslation(["designation", "common"])(DesignationForm);
